import { useEffect, useMemo } from 'react';
import useSportsbookBetslip from './use-sportsbook-betslip';
import { useLocation, type Location } from 'react-router-dom';
import { useRouter } from '~/utils/navigation';

const APPLY_BONUS_QUERY_PARAM = 'applybonus';

const useConsumeQueryApplyBonus = () => {
	const location = useLocation() as Location<{ search: string }>;
	const router = useRouter();
	const { setShouldApplyBonus } = useSportsbookBetslip();
	const queryParams = useMemo(() => new URLSearchParams(location.search), [location.search]);

	useEffect(() => {
		const shouldApplyBonus = queryParams.get(APPLY_BONUS_QUERY_PARAM);

		// Nullcheck to allow empty string where the parameter exists without a value
		if (shouldApplyBonus !== null) {
			setShouldApplyBonus(true);
			queryParams.delete(APPLY_BONUS_QUERY_PARAM);
			router.replace(`${location.pathname}?${queryParams.toString()}`);
		}
	}, [queryParams, setShouldApplyBonus, router, location.pathname]);
};

export default useConsumeQueryApplyBonus;
